import { render, staticRenderFns } from "./RoleEditIam.vue?vue&type=template&id=1dfec68e&scoped=true&"
import script from "./RoleEditIam.vue?vue&type=script&lang=ts&"
export * from "./RoleEditIam.vue?vue&type=script&lang=ts&"
import style0 from "./RoleEditIam.vue?vue&type=style&index=0&id=1dfec68e&prod&scoped=true&lang=css&"
import style1 from "./RoleEditIam.vue?vue&type=style&index=1&id=1dfec68e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfec68e",
  null
  
)

export default component.exports